import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { forgetPass, userLogin } from "./../../store/auth/authAction";
import { sucess, failed } from "../../component/toast/Toast";
import Bread from "../../component/Bread";
const Login = () => {
//   const { t } = useTranslation();
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const formik = useFormik({
//     initialValues: {
//       phone: "",
//       password: "",
//     },
//     validateOnChange: false,
//     onSubmit: (values) => {
//       dispatch(userLogin(values)).then((result) => {
//         if (result.payload.status === "error") {
//           failed(`${result.payload.message}`);
//         } else {
//           sucess(t("Login sucessfully"));
//           navigate("/");
//         }
//       });
//     },
//   });


// const [show, setShow] = useState(false);
// const [email, setEmail] = useState("");


// const handleResetEmail = async (e) => {
//   e.preventDefault();
//   if (email?.length > 0) {
//     try {
//       const result = await dispatch(forgetPass(email));
     
//       if (result.payload.status === "success") {
//         sucess(`${result.payload.message}`);
//         setShow(false);
//         setEmail("");
        
//       } else {
//         failed(t("invalid email address"));
//       }
//     } catch (error) {
      
//     }
//   } else {
//     failed(t("inputs can not be empty"));
//   }
// };
const [isLogin, setIsLogin] = useState(true);

const toggleForm = () => setIsLogin(!isLogin);
  return (
    <Fragment>
      <Bread title={"Home"} sub={"Login"}  />
        <section  className="login-wrapper login-wrapper-page">
            <div  className="container">
                <header className="hidden">
                    <h3 className="h3 title">Sign in</h3>
                </header>
                <div  className="row">
                 <div  className="col-md-6 col-md-offset-3">
               <div  className="login-wrapper">
      <div  className="white-block">
        <div  className={`form-container ${isLogin ? 'show-login' : 'show-register'}`}>
          <div  className="login-block login-block-log login-block-signin ">
            <div  className="h4 head-block">
              Sign in
              <button 
                onClick={toggleForm} 
                 className="btn btn-main btn-xs btn-register pull-right"
              >
                Create an account
              </button>
            </div>
            <hr />
            <div  className="row">
              <div  className="col-md-12">
                <div  className="form-group">
                  <input type="text"  className="form-control" placeholder="User ID" />
                </div>
              </div>
              <div  className="col-md-12">
                <div  className="form-group">
                  <input type="password"  className="form-control" placeholder="Password" />
                </div>
              </div>
              <div  className="col-xs-6">
                <span  className="checkbox">
                  <input type="checkbox" id="checkBoxId3" />
                  <label htmlFor="checkBoxId3">Remember me</label>
                </span>
              </div>
              <div  className="col-xs-6 text-right">
                <button  className="btn btn-main">Login</button>
              </div>
            </div>
          </div>

          <div  className="login-block login-block-signup">
            <div  className="h4 head-block">
              Register now
              <button 
                onClick={toggleForm} 
                 className="btn btn-main btn-xs btn-login pull-right"
              >
                Log in
              </button>
            </div>
            <hr />
            <div  className="row">
              <div  className="col-md-6">
                <div  className="form-group">
                  <input type="text"  className="form-control" placeholder="First name: *" />
                </div>
              </div>
              <div  className="col-md-6">
                <div  className="form-group">
                  <input type="text"  className="form-control" placeholder="Last name: *" />
                </div>
              </div>
              <div  className="col-md-12">
                <div  className="form-group">
                  <input type="text"  className="form-control" placeholder="Company name:" />
                </div>
              </div>
              <div  className="col-md-4">
                <div  className="form-group">
                  <input type="text"  className="form-control" placeholder="Zip code: *" />
                </div>
              </div>
              <div  className="col-md-8">
                <div  className="form-group">
                  <input type="text"  className="form-control" placeholder="City: *" />
                </div>
              </div>
              <div  className="col-md-6">
                <div  className="form-group">
                  <input type="text"  className="form-control" placeholder="Email: *" />
                </div>
              </div>
              <div  className="col-md-6">
                <div  className="form-group">
                  <input type="text"  className="form-control" placeholder="Phone: *" />
                </div>
              </div>
              <div  className="col-md-12">
                <hr />
                <span  className="checkbox">
                  <input type="checkbox" id="checkBoxId1" />
                  <label htmlFor="checkBoxId1">
                    I have read and accepted the <a href="#">terms</a>, as well as read and understood our terms of <a href="#">business conditions</a>
                  </label>
                </span>
                <span  className="checkbox">
                  <input type="checkbox" id="checkBoxId2" />
                  <label htmlFor="checkBoxId2">Subscribe to exciting newsletters and great tips</label>
                </span>
                <hr />
              </div>
              <div  className="col-md-12">
                <button  className="btn btn-main btn-block">Create account</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
                    </div>
                </div>

            </div>
        </section>
    </Fragment>
  );
};
export default Login;
